var map = {
	"./logo-icon": 5,
	"./logo-icon.png": 5,
	"./scansoles-logo": 6,
	"./scansoles-logo-big": 3,
	"./scansoles-logo-big.jpg": 21,
	"./scansoles-logo-big.png": 3,
	"./scansoles-logo.png": 6
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;